import { render, staticRenderFns } from "./HomepageLogin.vue?vue&type=template&id=5395ce2a"
import script from "./HomepageLogin.vue?vue&type=script&lang=js"
export * from "./HomepageLogin.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports